document.addEventListener("DOMContentLoaded", function () {
  var modals = document.getElementsByClassName("modal");
  var modalToggles = document.getElementsByClassName("modal-toggle");
  var modalCloses = document.getElementsByClassName("modal-close");

  Array.from(modalToggles).forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      var modalId = this.getAttribute("data-modal");
      var modal = document.getElementById(modalId);
      if (modal) {
        if (modal.style.display === "block") {
          modal.style.display = "none"; // Close the modal if it's open
          document.body.classList.remove("modal-active"); // Remove class when modal closes
        } else {
          modal.style.display = "block"; // Open the modal if it's closed
          document.body.classList.add("modal-active"); // Add class when modal opens
        }
      }
    });
  });

  Array.from(modalCloses).forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      Array.from(modals).forEach(function (modal) {
        modal.style.display = "none";
      });
      document.body.classList.remove("modal-active"); // Remove class when any modal closes
    });
  });

  window.onclick = function (event) {
    Array.from(modals).forEach(function (modal) {
      if (event.target == modal) {
        modal.style.display = "none";
        document.body.classList.remove("modal-active"); // Also remove class when clicking outside the modal
      }
    });
  };
});
